<div class="custom-mat-dialog-form">
  <div>
    <div>
      Contract line local name
      <br />
      <h4 class="not-translated">{{this.data.LineLocale}}</h4>
      <br />
      Correspond to contract line harmonized value: <br />
      <br />
    </div>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

      <div class="mt-2">

        <mat-select placeholder="Please select" style="width:300px;" class='form-control'
          name="ContractLine" required formControlName="ContractLine">
          @for (c of ContractLineHarmonizedValues; track c; let i = $index) {
            <mat-option value="{{c.ContractLineId}}">
              {{c.ContractLine}}
            </mat-option>
          }
        </mat-select>
      </div>

      <br />


      <div class="mt-2 right">
        <button type="button"
          class="btn btn-danger"
          (click)="onNoClick()">
          Cancel
        </button>
        <button type="button"
          class="btn btn-primary"
          (click)="onSubmit()">
          SAVE
        </button>
      </div>
    </form>
  </div>
</div>
